{
  "it": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "Sono presenti modifiche non salvate che andranno perse."
        }
      }
    }
  }
}
